import React, {useContext} from 'react';
import {Controller} from 'react-hook-form';
import {IFormFieldItemPropsContext} from '@src/@interfaces/contexts/IFormFieldItemPropsContext';
import {FormFieldDesignContext} from '@src/contexts/FormFieldDesignContext';
import FieldLayout from './FieldLayout';
import FormErrorMessage from '@src/components/Form/FormErrorMessage';
import {IOrderModel} from '@src/@interfaces/models/Order/IOrderModel';
import {FormFieldItemPropsContext} from '@src/contexts/FormFieldItemPropsContext';
import classnames from '@src/helpers/classnames';
import trans from '@src/helpers/trans';
import {LocaleContext} from '@src/contexts/LocaleContext';

export function DescriptionField({rowIndex: index, isDisabled, rows}: {
    rowIndex: number,
    isDisabled?: boolean,
    rows?: number,
}) {
    const {
        control,
        fieldName,
        forceReadonly,
        forceDisabled,
    } = useContext<IFormFieldItemPropsContext<IOrderModel> | null>(FormFieldItemPropsContext) ?? {};
    const [design] = useContext(FormFieldDesignContext);
    useContext(LocaleContext);

    if (!control) {
        return null;
    }

    return <FieldLayout
            id={`${fieldName}.${index}.description`}
            label="OrderForm.products.fields.description"
            className="mb-0"
    >
        <Controller
                control={control}
                name={`${fieldName}.${index}.description`}
                render={(
                        {
                            field: {
                                ref,
                                name,
                                value,
                                onChange,
                                onBlur
                            }, fieldState: {error}
                        }
                ) => {
                    return <textarea
                            ref={ref}
                            name={name}
                            id={name}
                            value={value ?? ''}
                            onChange={onChange}
                            onBlur={onBlur}
                            rows={rows}
                            className={classnames('form-control', {
                                'is-invalid': Boolean(error)
                            })}
                            readOnly={design.fieldsAreReadOnly || forceReadonly}
                            disabled={isDisabled || design.fieldsAreDisabled || forceDisabled}
                            placeholder={trans('OrderForm.products.fields.description')}
                    />;
                }}
        />

        <FormErrorMessage fieldName={`${fieldName}.${index}.description`}/>
    </FieldLayout>;
}
